import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CustomAlert from '../Common/CustomAlert';
import Loading from '../Common/Loading';

import btnAdd from '../Common/Images/add_d.gif';
import btnCancel from '../Common/Images/cancel_d.gif';

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const styles = {
    container: {
        backgroundColor: '#E8E8FF',
        fontFamily: 'Arial, sans-serif',
        position: 'absolute' as const,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '50px',
        overflow: 'auto',
        boxSizing: 'border-box' as const
    },
    wrapper: {
        width: '400px',
        textAlign: 'left' as const,
        maxWidth: '95%'
    },
    header: {
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '15px',
        backgroundColor: '#B0C4DE',
        padding: "10px",
        textAlign: 'center' as const,
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse' as const,


    },
    labelCell: {
        padding: '10px',
        textAlign: 'center' as const,
        width: '50%',
        fontWeight: 'bold',
    },
    valueCell: {
        padding: '10px',
        textAlign: 'left' as const,
        width: '50%',
    },
    dropdown: {
        fontFamily: 'Arial',
        fontSize: '9pt',
        width: '100px'
    },
    buttonGroup: {
        marginTop: '20px',
        textAlign: 'center' as const,
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        alignItems: 'center'
    },
    imgBtn: {
        cursor: 'pointer',
        height: '30px',
        width: 'auto'
    }
};

const EL_AddPoints: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);

    // Data State
    const [familyName, setFamilyName] = useState('');
    const [studentName, setStudentName] = useState('');
    const [currentPoints, setCurrentPoints] = useState(0);
    const [selectedPoints, setSelectedPoints] = useState('0');

    const [alertState, setAlertState] = useState({
        show: false,
        message: '',
        isSuccess: false
    });

    const schoolCode = searchParams.get('C');
    const familyCode = searchParams.get('F');
    const studentLogin = searchParams.get('L');

    const pointsOptions = ['500', '1000', '2000', '5000', '10000', '15000', '20000'];

    useEffect(() => {
        fetchStudentData();
    }, []);

    const fetchStudentData = async () => {
        setIsLoading(true);

        try {
            const response = await fetch(
                `${API_BASE_URL}api/get_student_points/ADD_POINTS?SchoolCode=${encodeURIComponent(schoolCode || '')}&FamilyCode=${encodeURIComponent(familyCode || '')}&Login=${encodeURIComponent(studentLogin || '')}`
            );

            const data = await response.json();

            if (data.status === 'success') {
                setFamilyName(data.familyName || '');
                setStudentName(data.studentName || '');
                setCurrentPoints(data.currentPoints || 0);
            } else {
                setAlertState({
                    show: true,
                    message: data.message || "Failed to load data",
                    isSuccess: false
                });
            }

        } catch (error) {
            console.error(error);

            setAlertState({
                show: true,
                message: "Error loading data",
                isSuccess: false
            });
        } finally {
            setIsLoading(false);
        }
    };

    // const handleConfirm = async () => {
    //     if (isLoading) return;

    //     if (!selectedPoints || selectedPoints === '0') {
    //         setAlertState({ show: true, message: "Please Select Points for Adding..", isSuccess: false });
    //         return;
    //     }

    //     setIsLoading(true);
    //     try {
    //         const payload = {
    //             SchoolCode: schoolCode,
    //             FamilyCode: familyCode,
    //             Login: studentLogin,
    //             PointsToAdd: parseInt(selectedPoints, 10)
    //         };

    //         const response = await fetch(`${API_BASE_URL}api/add_adhoc_points/`, {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(payload)
    //         });

    //         const result = await response.json();

    //         if (result.status === 'success') {
    //             setAlertState({ show: true, message: "Points Added Successfully.", isSuccess: true });
    //             // setCurrentPoints(prev => prev + parseInt(selectedPoints));
    //             setCurrentPoints(result.new_total);
    //             setSelectedPoints('0');
    //         } else {
    //             setAlertState({ show: true, message: "Failed to Add Points.", isSuccess: false });
    //         }

    //     } catch (error) {
    //         console.error(error);
    //         setAlertState({ show: true, message: "Error adding points", isSuccess: false });
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };



    const handleConfirm = async () => {
        if (isLoading) return;

        if (!selectedPoints || selectedPoints === '0') {
            setAlertState({
                show: true,
                message: "Please Select Points for Adding..",
                isSuccess: false
            });
            return;
        }

        setIsLoading(true);

        try {
            const payload = {
                SchoolCode: schoolCode,
                FamilyCode: familyCode,
                Login: studentLogin,
                PointsToAdd: parseInt(selectedPoints, 10)
            };

            const response = await fetch(
                `${API_BASE_URL}api/add_adhoc_points/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }
            );

            const result = await response.json();

            if (result.status === 'success') {
                setCurrentPoints(result.new_total);

                setSelectedPoints('0');

                setAlertState({
                    show: true,
                    message: "Points Added Successfully.",
                    isSuccess: true
                });
            } else {
                setAlertState({
                    show: true,
                    message: result.message || "Failed to Add Points.",
                    isSuccess: false
                });
            }

        } catch (error) {
            console.error(error);

            setAlertState({
                show: true,
                message: "Error adding points",
                isSuccess: false
            });
        } finally {
            setIsLoading(false);
        }
    };


    const handleCloseAlert = () => {
        setAlertState(prev => ({ ...prev, show: false }));
        if (alertState.isSuccess) {
            window.close();
        }
    };

    return (
        <div style={styles.container}>
            {isLoading && <Loading />}

            <div style={styles.wrapper}>
                <h2 style={styles.header}>
                    Add Points to Student: <span>{studentName || studentLogin}</span>
                </h2>

                <table style={styles.table}>
                    <tbody>
                        <tr>
                            <td style={styles.labelCell}>Family Name:</td>
                            <td style={styles.valueCell}>{familyName}</td>
                        </tr>
                        <tr>
                            <td style={styles.labelCell}>Current Points:</td>
                            <td style={styles.valueCell}>{currentPoints}</td>
                        </tr>
                        <tr>
                            <td style={styles.labelCell}>Select Points:</td>
                            <td style={styles.valueCell}>
                                <select
                                    style={styles.dropdown}
                                    value={selectedPoints}
                                    onChange={(e) => setSelectedPoints(e.target.value)}
                                >
                                    <option value="0">-Select-</option>
                                    {pointsOptions.map(p => (
                                        <option key={p} value={p}>{p}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style={styles.buttonGroup}>
                    <img
                        src={btnAdd}
                        alt="Add"
                        style={{ ...styles.imgBtn, opacity: isLoading ? 0.5 : 1 }}
                        onClick={handleConfirm}
                    />

                    <img
                        src={btnCancel}
                        alt="Cancel"
                        style={styles.imgBtn}
                        onClick={() => window.close()}
                    />
                </div>
            </div>

            {alertState.show && (
                <CustomAlert
                    message={alertState.message}
                    onClose={handleCloseAlert}
                />
            )}
        </div>
    );
};

export default EL_AddPoints;